/**
 * A stream is a data structure providing means to navigate through a collection.
 * The data is accessed via `fetch` which returns a Promise.
 *
 * @abstract
 */
export default class AbstractStream {
	/**
	 * Fetch the new data using a Promise.
	 *
	 * @abstract
	 * @return {Promise<object[]>}
	 */
	fetch() {
		throw new Error("Subclass responsibility");
	}
}
